/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Aside_Help_BodyInputs */

const en_contact_aside_help_body = /** @type {(inputs: Contact_Aside_Help_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most questions about booking, payments and your account have an answer there already.`)
};

const pl_contact_aside_help_body = /** @type {(inputs: Contact_Aside_Help_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na większość pytań o rezerwacje, płatności i konto jest tam już odpowiedź.`)
};

/**
* | output |
* | --- |
* | "Most questions about booking, payments and your account have an answer there already." |
*
* @param {Contact_Aside_Help_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_aside_help_body = /** @type {((inputs?: Contact_Aside_Help_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Aside_Help_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_aside_help_body(inputs)
	return en_contact_aside_help_body(inputs)
});